import { cn } from '@utils/tailwind.utils'
import { VERIFY_LOADER_KIND, VERIFY_LOADING_ATTR } from '@utils/verifyLoading'
import { HTMLAttributes } from 'react'
import omit from 'lodash/omit'

type SpinnerProps = HTMLAttributes<HTMLSpanElement> & { small?: boolean }

export function Spinner({ className, ...props }: SpinnerProps) {
  if (props.small) {
    return (
      <span
        className={cn(
          'spinner-base inline-block h-5 w-5 animate-spin rounded-full bg-cw-white p-1',
          className,
        )}
        {...{ [VERIFY_LOADING_ATTR]: VERIFY_LOADER_KIND.spinner }}
        {...omit(props, ['small'])}
      />
    )
  }

  return (
    <span
      className={cn(
        'spinner-base inline-block h-10 w-10 animate-spin rounded-full bg-cw-purple-dark p-1',
        className,
      )}
      {...{ [VERIFY_LOADING_ATTR]: VERIFY_LOADER_KIND.spinner }}
      {...props}
    />
  )
}
